export const accountancyRoute = '/troubleshoot/accountancy'
export const accountancyErrorList = '/troubleshoot/accountancy/errorlist/:shopID/:administrationSoftware'
export const accountancySoftwareRoute = '/troubleshoot/accountancy-software'
export const accountSettingsRoute = '/account-settings'
export const accountsStatsRoute = '/stats/accounts'
export const appointmentsStatsRoute = '/stats/appointments'
export const bankHolidaysRoute = '/bank-holidays'
export const bankHolidaysRouteEdit = '/bank-holidays/edit/:bankHolidayUUID'
export const bankHolidaysRouteNew = '/bank-holidays/new'
export const cacheRoute = '/cache'
export const developerSettingsDashboardRoute = '/dev-settings'
export const companyLicensesRoute = '/companies/edit/:companyUUID/licenses'
export const companyLicensesRouteFallback = '/companies/edit/:companyUUID#licenses'
export const companyLicensesRouteEdit = '/companies/:companyUUID/licenses/edit/:licenseUUID'
export const companyLicensesRouteNew = '/companies/:companyUUID/licenses/new'
export const companiesRoute = '/companies'
export const companiesRouteEdit = '/companies/edit/:companyUUID'
export const companiesRouteNew = '/companies/new'
export const conceptsRoute = '/concepts'
export const conceptsRouteEdit = '/concepts/edit/:conceptUUID'
export const conceptsRouteNew = '/concepts/new'
export const conversionRoute = '/conversion'
export const conversionRouteNew = '/conversion/new'
export const defaultRevenueRoute = '/troubleshoot/default-revenue-group'
export const distributorRoute = '/licenses/distributors'
export const distributorRouteEdit = '/licenses/distributors/edit/:distributorUUID'
export const distributorRouteNew = '/licenses/distributors/new'
export const employeesRoute = '/companies/:companyUUID/shops/:shopID/employees'
export const employeesRouteEdit = '/companies/:companyUUID/shops/:shopID/employees/edit/:employeeUUID'
export const employeesRouteEditFallback = '/companies/:companyUUID/shops/edit/:shopID#employees'
/*
  employeeRouteNewShop and employeesRouteNewFallback are needed to support
  the functionality of editing employees in non saved shops.
*/
export const employeeRouteNewShop = '/companies/:companyUUID/shops/new/employees'
export const employeesRouteNewFallback = '/companies/:companyUUID/shops/new#employees'
export const employeesRouteNew = '/companies/:companyUUID/shops/:shopID/employees/new'
export const externalApplicationStaticsRoute = '/external-application-statistics'
export const externalGMSRoute = '/external-gms'
export const externalGMSRouteEdit = '/external-gms/edit/:externalGMSUUID'
export const externalGMSRouteNew = '/external-gms/new'
export const externalSystemsRoute = '/companies/:companyUUID/shops/:shopID/external-systems'
export const externalSystemsRouteFallback = '/companies/:companyUUID/shops/edit/:shopID#externalsystems'
export const externalSystemsRouteEdit = '/companies/:companyUUID/shops/:shopID/external-systems/edit/:externalSystemUUID'
export const externalSystemsRouteNew = '/companies/:companyUUID/shops/:shopID/external-systems/new'
export const haynesproLicenseRoute = '/licenses/haynespro'
export const homeRoute = '/'
export const invoicesStatsRoute = '/stats/invoices'
export const licensesRoute = '/licenses'
export const loginRoute = '/auth/login'
export const logoutRoute = '/auth/logout'
export const mainProductGroupRouteEdit = '/product-group/:tree_uuid/main-group/:maingroup_uuid'
export const messagesRoute = '/messages'
export const messagesRouteEdit = '/messages/edit/:messageUUID'
export const messagesRouteNew = '/messages/new'
export const notAuthorizedRoute = '/401'
export const notFoundRoute = '/404'
export const orderLinesStatsRoute = '/stats/orderlines'
export const ordersStatsRoute = '/stats/orders'
export const productGroupRoute = '/product-group'
export const productGroupRouteList = '/product-group/list'
export const productGroupRouteTree = '/product-group/:tree_uuid'
export const regionsRoute = '/regions'
export const regionsRouteEdit = '/regions/edit/:regionTagUUID'
export const regionsRouteNew = '/regions/new'
export const releaseNotesRoute = '/release-notes'
export const releaseNotesRouteEdit = '/release-notes/edit/:UUID'
export const releaseNotesRouteNew = '/release-notes/new'
export const shopsRoute = '/shops'
export const shopsRouteCompanies = '/companies/:companyUUID/shops'
export const shopsRouteEdit = '/companies/:companyUUID/shops/edit/:shopID'
export const shopsRouteNew = '/companies/:companyUUID/shops/new'
export const shopsStatsRoute = '/stats/shops'
export const shopsTabRoute = '/shops/:shopID/:tab'
export const statsRoute = '/stats'
export const subProductGroupRouteEdit = '/product-group/:tree_uuid/main-group/:maingroup_uuid/sub-group/:subgroup_uuid'
export const telesalesRoute = '/telesales'
export const themesRoute = '/themes'
export const themesRouteEdit = '/themes/edit/:ThemeUUID'
export const themesRouteNew = '/themes/new'
export const translationsRoute = '/translations'
export const troubleshootRoute = '/troubleshoot'
export const wholesaleRoute = '/wholesale'
export const wholesaleRouteEdit = '/wholesale/edit/:wholesaleUUID'
export const wholesaleRouteList = '/wholesale/list'
export const wholesaleRouteNew = '/wholesale/new'
export const wholesaleFormRouteListPage = '/wholesale-forms'
export const warrantyRoute = '/warranty'
export const warrantyRouteEdit = '/warranty/edit/:warrantyUUID'
export const vehicleInvoicesStatsRoute = '/stats/vehicle-invoices'
export const vehiclesStatsRoute = '/stats/vehicles'
export const roadAssistance = '/road-assistance'
export const roadAssistanceNew = '/road-assistance/new'
export const roadAssistanceEdit = '/road-assistance/edit/:roadAssistanceProviderUUID'
export const activationPage = '/signUp'

// my changes of breadcrumbs
export const offerPackage = '/LKQ/OfferPackage'
export const onBoard = '/LKQ/OfferPackage/:customerId'
// export const onBoard = '/LKQ/OfferPackage/:formsubmitted?/:isFormSuccess?'
export const profileRoute = '/LKQ/Profile'
export const detailsRoute = '/LKQ/Profile/Details'
export const editingConcepts = '/LKQ/Profile/ConceptManagement'
export const conceptsRoute2 = '/LKQ/Concepts'
export const manageCustomerAccessRoute = '/LKQ/ManageCustomerAccess'
export const emailContentRoute = '/LKQ/EmailContent'
export const pendingEmailLogRoute = '/LKQ/PendingEmailList'
export const pendingEmailAttachment = '/LKQ/EmailAttachment'
export const salesGroupsRoute = '/LKQ/SalesGroups'
export const alerts = '/LKQ/Alerts'
export const configuration = '/LKQ/Settings'

export const conceptConfiguration = '/concept-configuration'
export const editConceptConfiguration = '/concept-configuration/edit/:conceptConfigurationUUID'
export const addConceptConfiguration = '/concept-configuration/new'

export default {
  offerPackage,
  onBoard,
  profileRoute,
  alerts,
  detailsRoute,
  editingConcepts,
  conceptsRoute2,
  manageCustomerAccessRoute,
  accountancyRoute,
  accountancyErrorList,
  accountancySoftwareRoute,
  accountSettingsRoute,
  accountsStatsRoute,
  appointmentsStatsRoute,
  bankHolidaysRoute,
  bankHolidaysRouteEdit,
  bankHolidaysRouteNew,
  cacheRoute,
  developerSettingsDashboardRoute,
  companyLicensesRoute,
  companyLicensesRouteFallback,
  companyLicensesRouteEdit,
  companyLicensesRouteNew,
  companiesRoute,
  companiesRouteEdit,
  companiesRouteNew,
  conversionRoute,
  conversionRouteNew,
  conceptsRoute,
  conceptsRouteEdit,
  conceptsRouteNew,
  defaultRevenueRoute,
  distributorRoute,
  distributorRouteEdit,
  distributorRouteNew,
  employeesRoute,
  employeeRouteNewShop,
  employeesRouteEdit,
  employeesRouteEditFallback,
  employeesRouteNewFallback,
  employeesRouteNew,
  externalApplicationStaticsRoute,
  externalGMSRoute,
  externalGMSRouteEdit,
  externalGMSRouteNew,
  externalSystemsRoute,
  externalSystemsRouteEdit,
  externalSystemsRouteFallback,
  externalSystemsRouteNew,
  haynesproLicenseRoute,
  homeRoute,
  invoicesStatsRoute,
  licensesRoute,
  loginRoute,
  logoutRoute,
  mainProductGroupRouteEdit,
  messagesRoute,
  messagesRouteEdit,
  messagesRouteNew,
  notAuthorizedRoute,
  notFoundRoute,
  orderLinesStatsRoute,
  ordersStatsRoute,
  productGroupRoute,
  productGroupRouteList,
  productGroupRouteTree,
  regionsRoute,
  regionsRouteEdit,
  regionsRouteNew,
  releaseNotesRoute,
  releaseNotesRouteEdit,
  releaseNotesRouteNew,
  shopsRoute,
  shopsRouteCompanies,
  shopsRouteEdit,
  shopsRouteNew,
  shopsStatsRoute,
  shopsTabRoute,
  statsRoute,
  subProductGroupRouteEdit,
  telesalesRoute,
  themesRoute,
  themesRouteEdit,
  themesRouteNew,
  translationsRoute,
  troubleshootRoute,
  wholesaleRoute,
  wholesaleRouteEdit,
  wholesaleRouteList,
  wholesaleRouteNew,
  wholesaleFormRouteListPage,
  warrantyRoute,
  warrantyRouteEdit,
  vehicleInvoicesStatsRoute,
  vehiclesStatsRoute,
  roadAssistance,
  roadAssistanceNew,
  roadAssistanceEdit,
  activationPage,
  pendingEmailLogRoute,
  emailContentRoute,
  pendingEmailAttachment,
  salesGroupsRoute,
  configuration,
  conceptConfiguration,
  editConceptConfiguration,
  addConceptConfiguration
}
